import { render, staticRenderFns } from "./printer.vue?vue&type=template&id=912f2edc&scoped=true&"
import script from "./printer.vue?vue&type=script&lang=js&"
export * from "./printer.vue?vue&type=script&lang=js&"
import style0 from "./printer.vue?vue&type=style&index=0&id=912f2edc&prod&lang=scss&scoped=true&"
import style1 from "./printer.vue?vue&type=style&index=1&id=912f2edc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "912f2edc",
  null
  
)

export default component.exports